<div class="bidder c11 doc-content" [style.max-width]="isTermsPage ? '100%' : ''">
 
  <h2 class="text-center my-3">Bidder User Terms</h2>

<div #viewContent style="height: 100%;"></div>
</div>

